import Marquee from "react-fast-marquee";

const ITEMS = [
  "REEFER / REFRIGERATED",
  "SPECIALIZED FREIGHT",
  "LONG-DISTANCE OTR",
  "EXPEDITED",
  "DRY VAN",
  "FLATBED",
];

export default function MarqueeBand() {
  return (
    <section
      data-testid="marquee"
      className="border-y border-white/10 bg-ink py-6 md:py-8"
      aria-label="Services marquee"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-[7vw] font-black uppercase tracking-tighter text-stroke md:text-[4.5vw]">
              {t}
            </span>
            <span className="mx-8 text-brand md:mx-14">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
